import { render, staticRenderFns } from "./LoginNoticeDialog.vue?vue&type=template&id=8e0c9cd2&scoped=true&"
import script from "./LoginNoticeDialog.vue?vue&type=script&lang=js&"
export * from "./LoginNoticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./LoginNoticeDialog.vue?vue&type=style&index=0&id=8e0c9cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0c9cd2",
  null
  
)

export default component.exports